<button
  class="opacity-80"
  mat-icon-button
  matTooltip="Practice Settings"
  ptElementTarget="view-settings-button"
  [matMenuTriggerFor]="moreMenu"
>
  <mat-icon>settings</mat-icon>
</button>
<mat-menu #moreMenu="matMenu" class="view-settings">
  <form
    class="mb-4"
    [formGroup]="practiceViewSettingsForm"
    (click)="$event.stopPropagation()"
  >
    <span class="p-2 text-xs font-semibold">Practice Settings</span>

    <pt-settings-menu-toggle-group-item
      label="Step Size (Mins)"
      formControlName="stepSizeInMins"
      ptElementTarget="step-size-button"
      [options]="stepSizesInMins"
      [disabled]="practiceSettingsDisabled$ | async"
    />

    <pt-settings-menu-toggle-group-item
      label="Hour Increments (Mins)"
      formControlName="hourIncrement"
      ptElementTarget="hour-increment-button"
      [options]="hourIncrements"
      [disabled]="practiceSettingsDisabled$ | async"
    />

    <pt-settings-menu-toggle-group-item
      label="Popover Delay"
      formControlName="tooltipDelay"
      ptElementTarget="popover-delay-button"
      [options]="tooltipDelays"
      [disabled]="practiceSettingsDisabled$ | async"
    />

    <mat-divider />

    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="text-xs font-semibold">Custom Colours</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngrxLet="eventColourPairs$ as pairs" class="flex flex-col gap-2">
          <div
            *ngFor="let pair of pairs; trackBy: trackByColourPair"
            class="flex items-center justify-between"
          >
            <span class="!text-xs">
              {{ pair.type | splitCamel | titlecase }}
            </span>
            <div class="flex items-center gap-4">
              @if (pair | map: hasColourOverride) {
                <button
                  class="sync-button opacity-70"
                  mat-icon-button
                  matTooltip="Revert to default"
                  (click)="saveEventColour(pair.type)"
                >
                  <mat-icon>sync</mat-icon>
                </button>
              }
              <pt-event-colour-picker
                [colour]="pair.colour"
                [disabled]="practiceSettingsDisabled$ | async"
                (colourChanged)="saveEventColour(pair.type, $event)"
              />
            </div>
          </div>

          <div class="flex items-center justify-between">
            <span class="!text-xs">Deadzone</span>
            <div class="flex items-center gap-4">
              @if (hasDeadzoneColourOverride$ | async) {
                <button
                  class="sync-button opacity-70"
                  mat-icon-button
                  matTooltip="Revert to default"
                  (click)="saveDeadzoneColour()"
                >
                  <mat-icon>sync</mat-icon>
                </button>
              }
              <pt-event-colour-picker
                [colour]="deadzoneColour$ | async"
                [palette]="deadzonePalette"
                [disabled]="practiceSettingsDisabled$ | async"
                [disableOpacity]="true"
                (colourChanged)="saveDeadzoneColour($event)"
              />
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="text-xs font-semibold">Status Indicators</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div
          *ngrxLet="groupedStatusIndicators$ as groups"
          class="flex flex-col gap-4"
        >
          <div
            *ngFor="let group of groups; trackBy: trackByCategory"
            class="flex flex-col gap-2"
          >
            <span class="text-xs font-semibold text-slate-500">
              {{ group.categoryLabel }}
            </span>
            <div
              *ngFor="
                let pair of group.indicators;
                trackBy: trackByStatusIndicator
              "
              class="flex items-center justify-between gap-2"
            >
              <span class="shrink-0 !text-xs">
                {{ pair.type | splitCamel | titlecase }}
              </span>
              <div class="flex items-center gap-2">
                @if (pair | map: hasStatusIndicatorOverride) {
                  <button
                    class="sync-button opacity-70"
                    mat-icon-button
                    matTooltip="Revert to default"
                    [disabled]="practiceSettingsDisabled$ | async"
                    (click)="saveStatusIndicator(pair.type)"
                  >
                    <mat-icon>sync</mat-icon>
                  </button>
                }
                <pr-status-indicator-picker
                  [config]="pair.config"
                  [disabled]="practiceSettingsDisabled$ | async"
                  [disableOpacity]="true"
                  (configChange)="
                    saveStatusIndicatorConfig(pair.type, pair.config, $event)
                  "
                />
                <mat-slide-toggle
                  color="primary"
                  class="scale-75"
                  [checked]="pair.config.enabled"
                  [disabled]="practiceSettingsDisabled$ | async"
                  [matTooltip]="
                    pair.config.enabled
                      ? 'Disable Status Indicator'
                      : 'Enable Status Indicator'
                  "
                  (change)="
                    saveStatusIndicatorEnabled(
                      pair.type,
                      pair.config,
                      $event.checked
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</mat-menu>
